module.exports = __webpack_public_path__ + "img/three3Orange.847be141.jpg";